import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import auth from "./auth";
import profile from "./profile";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [], // add here the reducers you want to save its data permenant
};

const rootReducer = combineReducers({
  auth,
  profile,
});

export default persistReducer(persistConfig, rootReducer);
